import * as React from "react";
import Button from "@mui/material/Button";
import {
  ButtonGroup as MuiButtonGroup,
  Typography as MuiTypography
} from "@mui/material";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Grow from "@mui/material/Grow";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";
import styled from "@emotion/styled";
import ArrowDropDownIcon from "../../assets/icons/arrobutton.png";

const Typography = styled(MuiTypography)``;
const TypographyButtonSlectedValue = styled(MuiTypography)`
  color: #192f67;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-transform: capitalize;
`;

const TypographyArrowDropDownIcon = styled(MuiTypography)`
  width: 10px;
  display: flex;
  align-items: center;
  height: 5px;
  flex-shrink: 0;
  stroke-width: 1px;
  stroke: #192f67;
`;
const ButtonGroup = styled(MuiButtonGroup)`
  display: flex;
  width: 88px;
  padding: 6px 18px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 41px;
  border: 1px solid #192f67;
`;
const filterByName: any = {
  Today: "today",
  Week: "week",
  Month: "month"
};
interface ButtonDropDownProps {
  children: string;
  menusOption: Array<Object> | any[];
  getTransactions: (data: string | any, value: any) => void | any;
  title: any;
}

const ButtonDropDown: React.FC<ButtonDropDownProps> = ({
  children = "",
  menusOption = [],
  getTransactions = () => {},
  title = ""
}) => {
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef<HTMLDivElement>(null);
  const [selectedIndex, setSelectedIndex] = React.useState(0);

  const handleMenuItemClick = (
    event: React.MouseEvent<HTMLLIElement, MouseEvent>,
    index: number
  ) => {
    setSelectedIndex(index);
    let key = menusOption[index];
    getTransactions(filterByName[key], title);
    setOpen(false);
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event: Event) => {
    if (
      anchorRef.current &&
      anchorRef.current.contains(event.target as HTMLElement)
    ) {
      return;
    }

    setOpen(false);
  };

  return (
    <React.Fragment>
      <ButtonGroup
        variant="contained"
        ref={anchorRef}
        aria-label="split button"
        onClick={handleToggle}
      >
        <TypographyButtonSlectedValue>
          {menusOption[selectedIndex]}
        </TypographyButtonSlectedValue>
        <TypographyArrowDropDownIcon>
          <img src={ArrowDropDownIcon} />
        </TypographyArrowDropDownIcon>
      </ButtonGroup>
      <Popper
        sx={{
          zIndex: 1
        }}
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === "bottom" ? "center top" : "center bottom"
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList id="split-button-menu" autoFocusItem>
                  {menusOption.map((option, index) => (
                    <MenuItem
                      key={option}
                      selected={index === selectedIndex}
                      onClick={(event) => handleMenuItemClick(event, index)}
                    >
                      {option}
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </React.Fragment>
  );
};

export default ButtonDropDown;
